import React from "react";
import LatestProductScreenshot from "../../assets/logo-buzzline.png";
import GooglePlayBadge from "../../assets/google_play_badge.png";

const LatestProduct = () => {

    const styleLatestProductImage = {
        maxHeight: "440px"
    };

    return (<div id="latestProduct" className="latest-product-main">
        <h3>Products</h3>
        <h1>Latest Product</h1>
        <div className="latest-product-container">
            <div className="latest-product-column">
                <img style={styleLatestProductImage} src={LatestProductScreenshot} alt="Latest Product Screenshot"/>
            </div>
            <div className="latest-product-column">
                <h3>BuzzLine</h3>
                <p>Catch the Buzz. Stay informed on what matters.</p>
                <a href="https://play.google.com/store/apps/details?id=com.noblenotch.buzzline&pcampaignid=web_share" target="_blank" rel="noreferrer">
                    <img style={{marginTop: "24px"}} className="google-play-badge" src={GooglePlayBadge}
                         alt="Download On PlayStore"/>
                </a>
            </div>
        </div>
    </div>);
}

export default LatestProduct
//
// import React from "react";
// import LatestProductScreenshot from "../../assets/icon_guessrush.png";
// import GooglePlayBadge from "../../assets/google_play_badge.png";
//
// const LatestProduct = () => {
//
//     const styleLatestProductImage = {
//         maxHeight: "440px"
//     };
//
//     return (<div id="latestProduct" className="latest-product-main">
//         <h3>Products</h3>
//         <h1>Latest Product</h1>
//         <div className="latest-product-container">
//             <div className="latest-product-column">
//                 <img style={styleLatestProductImage} src={LatestProductScreenshot} alt="GuessRush app icon"/>
//             </div>
//             <div className="latest-product-column">
//                 <h3>GuessRush</h3>
//                 <p>Guess with us in 3 seconds. A fast, multi-category quiz game.</p>
//                 <a href="https://play.google.com/store/apps/details?id=com.noblenotch.guessrush&pcampaignid=web_share" target="_blank" rel="noreferrer">
//                     <img style={{marginTop: "24px"}} className="google-play-badge" src={GooglePlayBadge}
//                          alt="Download On PlayStore"/>
//                 </a>
//             </div>
//         </div>
//     </div>);
// }
//
// export default LatestProduct
